<template>
  <BreadCrumb PageTitle="Transports" />
  <TransportSettings />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import TransportSettings from "../../components/Generals/AccountSettings/TransportSettings.vue";

export default defineComponent({
  name: "TransportsPage",
  components: {
    BreadCrumb,
    TransportSettings,
  },
});
</script>
